import React from 'react';

import { useParams } from 'react-router-dom';
import MainBlock from '../../shared/web/layout/MainBlock';
import TextField from '../../shared/uibuilder/show/field/TextField';
import ProjectNotes from './ProjectNotes';
import UpdateProjectForm from './UpdateProjectForm';
import DetailsFieldsList from './DetailsFieldsList';
import ProjectPagesButtons from '../view/ProjectPagesButtons';
import Separator from '../../shared/web/uitheme/form/Separator';
import { ProjectBreadcrumb } from '../view/ProjectContext';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import ProjectDetailsPageTour from './ProjectDetailsPageTour';
import {
  ApplicationSettingsNavigationContext,
  ProjectExternalLinksBlock,
  ProjectTypeField
} from 'features/tasks-forms';
import { ProjectIdContext } from 'features/nekst-widgets';
import useFeatureToggleService, { NewUpdateTransactionFormToggleWrapper } from 'feature-toggle';
import useSettingsNavigator from '../../settings/settingsNavigator';
import AppliedWorkflowsBlock from './AppliedWorkflowsBlock';
import ShadcnProjectDetails from './ShadcnProjectDetails';

function ProjectDetailsBreadcrumbs() {
  return (
    <ProjectBreadcrumb>
      <Breadcrumb text="Details" />
    </ProjectBreadcrumb>
  );
}

export default function ProjectDetails() {
  const params = useParams();

  const projectId = parseInt(params.id!, 10);

  const settingsNavigator = useSettingsNavigator();

  const { isShadcnUiEnabled, isShadcnTransactionDetailEnabled } = useFeatureToggleService();

  const useShadcnTransactionDetail = isShadcnUiEnabled() && isShadcnTransactionDetailEnabled();

  if (useShadcnTransactionDetail) {
    return (
      <ProjectIdContext projectId={projectId}>
        <ProjectDetailsBreadcrumbs />
        <ShadcnProjectDetails />
      </ProjectIdContext>
    );
  } else {
    return (
      <ProjectIdContext projectId={projectId}>
        <ProjectDetailsBreadcrumbs />
        <MainBlock
          title={<TextField source="name" />}
          titleLine2={<ProjectTypeField />}
          headerRight={(
            <ProjectPagesButtons />
          )}
          columnContent={(
            <>
              <UpdateProjectForm
                projectId={projectId}
              />

              <NewUpdateTransactionFormToggleWrapper>
                <AppliedWorkflowsBlock projectId={projectId} />
              </NewUpdateTransactionFormToggleWrapper>

              <ApplicationSettingsNavigationContext openApplicationSettingsFunc={settingsNavigator.openFubProfilesPage}>
                <ProjectExternalLinksBlock projectId={projectId} />
              </ApplicationSettingsNavigationContext>
            </>
          )}
        >
          <DetailsFieldsList projectId={projectId} />
          <ProjectNotes projectId={projectId} />
          <Separator marginSize="big" />
          <ProjectDetailsPageTour />
        </MainBlock>
      </ProjectIdContext>
    );
  }
}
